import { render, staticRenderFns } from "./bjdetail.vue?vue&type=template&id=7b83a8e0&scoped=true&"
import script from "./bjdetail.vue?vue&type=script&lang=js&"
export * from "./bjdetail.vue?vue&type=script&lang=js&"
import style0 from "./bjdetail.vue?vue&type=style&index=0&id=7b83a8e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83a8e0",
  null
  
)

export default component.exports